import { formatDate } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-district-representativewise-sadhyasthiti-report',
  // standalone: true,
  // imports: [],
  templateUrl: './district-representativewise-sadhyasthiti-report.component.html',
  styleUrl: './district-representativewise-sadhyasthiti-report.component.scss'
})
export class DistrictRepresentativewiseSadhyasthitiReportComponent implements OnInit {
 isLoading: boolean = false;
  startDate = '';
  endDate = '';
  // prantData;
  // showPrantData = [
  //   { prantName: 'कोकण प्रांत' },
  //   { prantName: 'पश्चिम प्रांत' },
  //   { prantName: 'देवगिरी प्रांत' },
  //   { prantName: 'विदर्भ प्रांत' },
  //   { prantName: 'अन्य प्रांत' },
  // ];
  // showOtherPrantData = [];
  totalPostTotal = 0;
  totalHasteTotal = 0;
  totalMagzineTotal = 0;
  totalDigitalTotal = 0;

  prantData: any[] = [];

showPrantData: any[] = [
  { prantName: 'कोकण प्रांत', data: [] },
  { prantName: 'पश्चिम प्रांत', data: [] },
  { prantName: 'देवगिरी प्रांत', data: [] },
  { prantName: 'विदर्भ प्रांत', data: [] },
  { prantName: 'अन्य प्रांत', data: [] },
];

showOtherPrantData: any[] = [];

representativeData: any[] = [];
grandTotal = 0;

  constructor(
    private dialogRef: MatDialogRef<DistrictRepresentativewiseSadhyasthitiReportComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {
    this.isLoading = true;
    this.prantData = this.data['data'];
    // console.log(this.prantData);
    const rawData = this.data['data'] || [];

    this.endDate = this.data['issuedate'];
    let weekfirstday =
      new Date(this.data['issuedate']).getDate() -
      new Date(this.data['issuedate']).getDay();
    this.startDate = formatDate(
      new Date(this.data['issuedate']).setDate(weekfirstday - 7),
      'yyyy-MM-dd',
      'en-IN',
      'GMT+0530'
    );

    // this.setPrantData();

    this.setRepresentativeData(rawData);

    this.isLoading = false;
  }

  //Old Code 
// setPrantData() {

//   this.totalPostTotal = 0;
//   this.totalHasteTotal = 0;
//   this.totalMagzineTotal = 0;
//   this.totalDigitalTotal = 0;

//   this.showOtherPrantData = [];

//   this.showPrantData.forEach(p => p.data = []);

//   const isMaha = (a:any) =>
//     a.state === 'महाराष्ट्र' ||
//     (a.state === 'गोवा' && a.prant_name === 'कोकण प्रांत');

//   const countMode = (arr:any[], mode:string) =>
//     arr.reduce((count, a) => {
//       const delivery = (a.delivery_mode || '').toString().trim();
//       return delivery === mode ? count + 1 : count;
//     }, 0);

//   let mahaState = this.prantData.filter(isMaha);
//   let otherState = this.prantData.filter(a => !isMaha(a));

//   /* ---------- OTHER PRANT ---------- */

//   let otherPost = countMode(otherState, 'टपाल');
//   let otherHaste = countMode(otherState, 'हस्ते');
//   let otherMagzine = countMode(otherState, 'मॅगझीन पोस्ट');
//   let otherDigital = countMode(otherState, 'डिजिटल');

//   this.showOtherPrantData.push({
//     name: 'अन्यप्रांत',
//     post: otherPost,
//     haste: otherHaste,
//     magazine: otherMagzine,
//     digital: otherDigital,
//     total: otherPost + otherHaste + otherMagzine + otherDigital,
//   });

//   this.showOtherPrantData.push({
//     name: 'परदेश',
//     post: 0,
//     haste: 0,
//     magazine: 0,
//     digital: 0,
//     total: 0,
//   });

//   this.totalPostTotal += otherPost;
//   this.totalHasteTotal += otherHaste;
//   this.totalMagzineTotal += otherMagzine;
//   this.totalDigitalTotal += otherDigital;

//   /* ---------- PRANT ---------- */

//   let prants:any[] = this.uniqueData(mahaState, (a:any) => a.prant_name);

//   for (let prant of prants) {

//     let prantRows = mahaState.filter(a => a.prant_name === prant.prant_name);
//     let districts:any[] = this.uniqueData(prantRows, (a:any) => a.district);

//     let prantData:any[] = [];

//     for (let dist of districts) {

//       let districtRows = prantRows.filter(a => a.district === dist.district);

//       // ✅ FIXED HERE
//       let representatives:any[] = this.uniqueData(
//         districtRows,
//         (a:any)=>a.rep_name
//       );

//       let repData:any[] = [];

//       let districtPost = 0;
//       let districtHaste = 0;
//       let districtMagazine = 0;
//       let districtDigital = 0;

//       for (let rep of representatives) {

//         let repRows = districtRows.filter(
//           a => a.rep_name === rep.rep_name
//         );

//         let post = countMode(repRows, 'टपाल');
//         let haste = countMode(repRows, 'हस्ते');
//         let magazine = countMode(repRows, 'मॅगझीन पोस्ट');
//         let digital = countMode(repRows, 'डिजिटल');

//         this.totalPostTotal += post;
//         this.totalHasteTotal += haste;
//         this.totalMagzineTotal += magazine;
//         this.totalDigitalTotal += digital;

//         districtPost += post;
//         districtHaste += haste;
//         districtMagazine += magazine;
//         districtDigital += digital;

//         repData.push({
//           rep_name: rep.rep_name,
//           taluka: rep.taluka || '',
//           post,
//           haste,
//           magazine,
//           digital,
//           total: post + haste + magazine + digital
//         });
//       }

//       prantData.push({
//         districtName: dist.district,
//         representatives: repData,
//         post: districtPost,
//         haste: districtHaste,
//         magazine: districtMagazine,
//         digital: districtDigital,
//         total: districtPost + districtHaste + districtMagazine + districtDigital
//       });
//     }

//     const target = this.showPrantData.find(p => p.prantName === prant.prant_name);

//     if (target) {
//       target.data = prantData;
//     }
//   }

//   this.isLoading = false;
// }

//Old Correct Code
// setRepresentativeData(data: any[]) {

//   /* ===============================
//      RESET TOTALS
//   =============================== */

//   this.totalPostTotal = 0;
//   this.totalHasteTotal = 0;
//   this.totalMagzineTotal = 0;
//   this.totalDigitalTotal = 0;
//   this.grandTotal = 0;

//   const repMap = new Map<string, any>();

//   /* ===============================
//      STEP 1: REPRESENTATIVE COUNT (UNCHANGED)
//   =============================== */

//   data.forEach(item => {

//     const rep_district =
//       item?.rep_district ||
//       (item?.district_taluka
//         ? item.district_taluka.split('-')[0].trim()
//         : '');

//     const prant =
//       item?.prant ||
//       item?.prant_name ||
//       '';

//     const repName = item?.rep_name || ' ';
//     const rep_taluka = item?.rep_taluka || ' ';

//     const key = rep_district + '_' + repName;

//     if (!repMap.has(key)) {
//       repMap.set(key, {
//         rep_district,
//         prant,
//         repName,
//         rep_taluka,
//         post: 0,
//         haste: 0,
//         magazine: 0,
//         digital: 0,
//         total: 0
//       });
//     }

//     const rep = repMap.get(key);
//     const mode = item?.delivery_mode?.trim();

//     if (mode === 'टपाल') {
//       rep.post++;
//       this.totalPostTotal++;
//     }
//     else if (mode === 'हस्ते') {
//       rep.haste++;
//       this.totalHasteTotal++;
//     }
//     else if (mode === 'मॅगझीन पोस्ट') {
//       rep.magazine++;
//       this.totalMagzineTotal++;
//     }
//     else if (mode === 'डिजिटल') {
//       rep.digital++;
//       this.totalDigitalTotal++;
//     }

//   });

//   /* ===============================
//      STEP 2: CALCULATE REP TOTAL (UNCHANGED)
//   =============================== */

//   const flatRepresentativeData = Array.from(repMap.values());

//   flatRepresentativeData.forEach(rep => {
//     rep.total = rep.post + rep.haste + rep.magazine + rep.digital;
//     this.grandTotal += rep.total;
//   });

//   /* ===============================
//      STEP 3: GROUP INTO PRANT → DISTRICT
//      (ONLY STRUCTURE CHANGED)
//   =============================== */

//   const prantMap = new Map<string, any>();

//   flatRepresentativeData.forEach(rep => {

//     /* CREATE PRANT */
//     if (!prantMap.has(rep.prant)) {
//       prantMap.set(rep.prant, {
//         prant: rep.prant,
//         districts: new Map()
//       });
//     }

//     const prantObj = prantMap.get(rep.prant);

//     /* CREATE DISTRICT UNDER PRANT */
//     if (!prantObj.districts.has(rep.rep_district)) {
//       prantObj.districts.set(rep.rep_district, {
//         rep_district: rep.rep_district,
//         representatives: [],
//         districtPost: 0,
//         districtHaste: 0,
//         districtMagazine: 0,
//         districtDigital: 0,
//         districtTotal: 0
//       });
//     }

//     const districtObj = prantObj.districts.get(rep.rep_district);

//     /* PUSH REPRESENTATIVE */
//     districtObj.representatives.push(rep);

//     /* DISTRICT TOTAL FROM REP TOTAL (UNCHANGED LOGIC) */
//     districtObj.districtPost += rep.post;
//     districtObj.districtHaste += rep.haste;
//     districtObj.districtMagazine += rep.magazine;
//     districtObj.districtDigital += rep.digital;
//     districtObj.districtTotal += rep.total;

//   });

//   /* ===============================
//      FINAL CONVERSION
//   =============================== */

//   this.representativeData = Array.from(prantMap.values()).map(prant => {
//     return {
//       ...prant,
//       districts: Array.from(prant.districts.values())
//     };
//   });

// }

//Prant Arrange In Order New Correct Code
setRepresentativeData(data: any[]) {

  /* ===============================
     RESET TOTALS
  =============================== */

  this.totalPostTotal = 0;
  this.totalHasteTotal = 0;
  this.totalMagzineTotal = 0;
  this.totalDigitalTotal = 0;
  this.grandTotal = 0;

  const repMap = new Map<string, any>();

  /* ===============================
     STEP 1: REPRESENTATIVE COUNT (UNCHANGED)
  =============================== */

  data.forEach(item => {

    const rep_district =
      item?.rep_district ||
      (item?.district_taluka
        ? item.district_taluka.split('-')[0].trim()
        : '');

    const prant =
      item?.prant ||
      item?.prant_name ||
      '';

    const repName = item?.rep_name || ' ';
    const rep_taluka = item?.rep_taluka || ' ';

    const key = rep_district + '_' + repName;

    if (!repMap.has(key)) {
      repMap.set(key, {
        rep_district,
        prant,
        repName,
        rep_taluka,
        post: 0,
        haste: 0,
        magazine: 0,
        digital: 0,
        total: 0
      });
    }

    const rep = repMap.get(key);
    const mode = item?.delivery_mode?.trim();

    if (mode === 'टपाल') {
      rep.post++;
      this.totalPostTotal++;
    }
    else if (mode === 'हस्ते') {
      rep.haste++;
      this.totalHasteTotal++;
    }
    else if (mode === 'मॅगझीन पोस्ट') {
      rep.magazine++;
      this.totalMagzineTotal++;
    }
    else if (mode === 'डिजिटल') {
      rep.digital++;
      this.totalDigitalTotal++;
    }

  });

  /* ===============================
     STEP 2: CALCULATE REP TOTAL
  =============================== */

  const flatRepresentativeData = Array.from(repMap.values());

  flatRepresentativeData.forEach(rep => {
    rep.total = rep.post + rep.haste + rep.magazine + rep.digital;
    this.grandTotal += rep.total;
  });

  /* ===============================
     STEP 3: FIX DISTRICT → PRANT DUPLICATION
  =============================== */

  // This map ensures one district belongs to only ONE prant
  const districtPrantMap = new Map<string, string>();

  flatRepresentativeData.forEach(rep => {
    if (!districtPrantMap.has(rep.rep_district)) {
      districtPrantMap.set(rep.rep_district, rep.prant);
    }
    // Force same district to use first detected prant
    rep.prant = districtPrantMap.get(rep.rep_district);
  });

  /* ===============================
     STEP 4: GROUP INTO PRANT → DISTRICT
  =============================== */

  const prantMap = new Map<string, any>();

  flatRepresentativeData.forEach(rep => {

    if (!prantMap.has(rep.prant)) {
      prantMap.set(rep.prant, {
        prant: rep.prant,
        districts: new Map()
      });
    }

    const prantObj = prantMap.get(rep.prant);

    if (!prantObj.districts.has(rep.rep_district)) {
      prantObj.districts.set(rep.rep_district, {
        rep_district: rep.rep_district,
        representatives: [],
        districtPost: 0,
        districtHaste: 0,
        districtMagazine: 0,
        districtDigital: 0,
        districtTotal: 0
      });
    }

    const districtObj = prantObj.districts.get(rep.rep_district);

    districtObj.representatives.push(rep);

    districtObj.districtPost += rep.post;
    districtObj.districtHaste += rep.haste;
    districtObj.districtMagazine += rep.magazine;
    districtObj.districtDigital += rep.digital;
    districtObj.districtTotal += rep.total;

  });

  /* ===============================
     FINAL CONVERSION
  =============================== */

  const prantOrder = [
    'कोकण प्रांत',
    'पश्चिम प्रांत',
    'देवगिरी प्रांत',
    'विदर्भ प्रांत',
    'अन्य प्रांत'
  ];

  this.representativeData = Array.from(prantMap.values())
    .map(prant => {
      return {
        ...prant,
        districts: Array.from(prant.districts.values())
      };
    })
    .sort((a, b) => {
      const indexA = prantOrder.indexOf(a.prant);
      const indexB = prantOrder.indexOf(b.prant);

      return (indexA === -1 ? 999 : indexA) - (indexB === -1 ? 999 : indexB);
    });

}

// uniqueData(data, key) {
//   return [...new Map(data.map((a) => [key(a), a])).values()];
// }

uniqueData(data: any[], key: (item:any)=>any): any[] {
  return [...new Map(data.map((a) => [key(a), a])).values()];
}



  exportExcel(fileName) {
    /* table id is passed over here */
    let element = document.getElementById('print-section');
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, fileName + '.xlsx');
  }


printPage() {

  const element = document.getElementById('print-section');

  if (!element) {
    console.error("Print section not found!");
    return;
  }

  const printWindow = window.open('', '_blank');

  if (!printWindow) {
    console.error("Failed to open print window.");
    return;
  }

  printWindow.document.write(`
  <html>
  <head>
    <title>Ultra Print</title>

    <style>

    @page{
        size:A4 portrait;
        margin:8mm;
    }

    body{
        margin:0;
        font-family: Arial, Helvetica, sans-serif;
    }

    /* 🔥 CORE TABLE — AUTO COLUMN WIDTH */
   table{
    width:max-content;   /* ⭐ MAGIC */
    min-width:100%;
    border-collapse:collapse;
    border:2px solid #000;
    table-layout:auto;
}


    th, td{
        border:1px solid #000;
        padding:6px 8px;
        white-space:nowrap;     /* ⭐ NEVER BREAK ROW */
    }

    thead th{
        font-size:14px;
        font-weight:700;
        text-align:center;
        background:#f5f5f5;
    }

    tbody td{
        font-size:13px;
    }

    /* ✅ SERIAL — VERY SMALL */
    table th:nth-child(1),
    table td:nth-child(1){
        width:1%;
        white-space:nowrap;
        text-align:center;
    }

    table th:nth-child(2),
    table td:nth-child(2){
        width:1%;
        white-space:nowrap;
        text-align:center;
    }

    /* ✅ ⭐⭐⭐ ULTRA FLEXIBLE 2ND COLUMN ⭐⭐⭐ */
  /* ✅ PERFECT FLEXIBLE 2ND COLUMN */

table td:nth-child(3){

    width:auto;          /* ⭐ KEY FIX */
    min-width:50px;     /* prevents collapsing */

    white-space:nowrap;  
    word-break:keep-all; 
    overflow:hidden;
    text-overflow:ellipsis;

    text-align:center;
}


table td:nth-child(3){

    width:auto;          /* ⭐ KEY FIX */
    min-width:50px;     /* prevents collapsing */

    white-space:nowrap;  
    word-break:keep-all; 
    overflow:hidden;
    text-overflow:ellipsis;

    text-align:left;
}


    /* ✅ POST */
    table th:nth-child(4),
    table td:nth-child(4){
        width:1%;
        white-space:nowrap;
        text-align:center;
    }

    /* ✅ OTHER NUMERIC */
    table th:nth-child(n+5),
    table td:nth-child(n+5){
        width:1%;
        white-space:nowrap;
        text-align:center;
    }

    table tbody tr:last-child{
        font-weight:700;
        background:#efefef;
    }

    /* 🔥 PRINT FIX */
    @media print{

        body{
            margin:0;
        }

        #print-section{
            overflow:visible;
        }

        thead{
            display:table-header-group;
        }

        tr{
            page-break-inside:avoid;
        }

        .noPrint{
            display:none !important;
        }
    }

    </style>
  </head>

  <body>
    ${element.outerHTML}

    <script>
      window.onload = function(){
        setTimeout(function(){
          window.focus();
          window.print();
          window.close();
        }, 300);
      }
    <\/script>

  </body>
  </html>
  `);

  printWindow.document.close();
}



}
